import { gql } from '@apollo/client';

import { StudentSession } from '../../types';

export interface GetActiveSessionQueryVariables {
  email: string;
}

export interface GetActiveSessionQueryResult {
  session: StudentSession | null;
}

export const getActiveSessionQuery = gql`
  query GetActiveSession($email: String!) {
    session(email: $email) @rest(type: "Session", path: "auth/active-session?email={args.email}") {
      id
      platform
      createdAt
    }
  }
`;
